import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

import { eventDateString, eventMarkup } from '../../common/misc';
import * as choiceApi from '../../api/choice';

import './Calendar.scss';
import { ReserveButton } from '../Reservations/ReserveButton';

export function ClubEvent({
    event,
}) {
    const navigate = useNavigate();

    if (!event || !event.start) {
        return null;
    }

    const dateStr = eventDateString(event);
    const markup = eventMarkup(event);

    return (
        <div className="club-event">
            <div className="event-icon d-none d-md-block">
                <img src={`/event_icons/${event.icon}`} alt="event icon" />
            </div>
            <div className="event-content">
                <div className="event-header">
                    <div className="event-title">{event.title}</div>
                    <div className="event-date">{dateStr}</div>
                </div>
                <div className="event-icon d-md-none">
                    <img src={`/event_icons/${event.icon}`} alt="event icon" />
                </div>
                <div className="event-body">
                    <span className="event-desc" dangerouslySetInnerHTML={{ __html: markup }} />
                    <ReserveButton color="primary" size="sm" event={event} onClick={() => navigate(`/member/reservation/${event.id}`)} />
                </div>
            </div>
        </div>
    );
}


export function Calendar(props) {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        async function loadData() {
            const eventList = await choiceApi.getEvents();
            if (eventList) {
                setEvents(eventList);
            }
        }

        loadData();

    }, [])

    const displayEvents = events.map((e) =>
        <ClubEvent key={`event-${e.id}`} event={e} />
    );


    return (
        <Container className="calendar">
            <h1>Upcoming Events</h1>
            {displayEvents}
        </Container>
    );
}
